import Portateis from './portateis';

export default Portateis;